var _a, _b;
import { __decorate, __metadata, __param } from "tslib";
import { injectable, inject } from '@patsnap/tahiti-core/shared/inversify';
import { EditSpaceRepository } from './edit-space-service.interface';
import { SpacesModel } from '../model/spaces-model';
let EditSpaceServiceImpl = class EditSpaceServiceImpl {
    constructor(_spacesModel, _editSpaceRepository) {
        this._spacesModel = _spacesModel;
        this._editSpaceRepository = _editSpaceRepository;
    }
    async editSpace(data) {
        const result = await this._editSpaceRepository.editSpace(data);
        this._spacesModel.update(spaces => this._editSpace(spaces, result));
        return result;
    }
    _editSpace(spaces, result) {
        return spaces.map(space => this._updateSpaceOrNot(space, result));
    }
    _updateSpaceOrNot(existingSpace, result) {
        if (existingSpace.spaceId === result.spaceId) {
            return {
                ...existingSpace,
                ...result,
            };
        }
        return existingSpace;
    }
};
EditSpaceServiceImpl = __decorate([
    injectable(),
    __param(0, inject(SpacesModel)),
    __param(1, inject(EditSpaceRepository)),
    __metadata("design:paramtypes", [typeof (_a = typeof SpacesModel !== "undefined" && SpacesModel) === "function" ? _a : Object, typeof (_b = typeof EditSpaceRepository !== "undefined" && EditSpaceRepository) === "function" ? _b : Object])
], EditSpaceServiceImpl);
export { EditSpaceServiceImpl };
